<template>
  <div class="network-status-table">
    <div class="network-status-table__row mb-3">
      <multi-level-table
        class="network-status-table__table"
        no-padding-children
        :items="items"
        :levels="levels"
        :headers="headers"
        :sort-by.sync="sortByProxy"
        :sort-direction.sync="sortDirectionProxy"
        :loading="loading"
        @sort-changed="$emit('sort-changed', $event)"
      >
        <network-status-badge
          slot="allLevels.networkStatus"
          slot-scope="data"
          :value="data.data.networkStatus"
        />
        <module-status-badge
          slot="allLevels.status"
          slot-scope="data"
          :value="data.data.status"
        />
        <module-self-diagnosis-status-badge
          slot="allLevels.moduleSelfDiagnosisStatus"
          slot-scope="data"
          :value="data.data.moduleSelfDiagnosisStatus"
        />
        <b-button
          class="network-status-table__reset-button"
          variant="outline-secondary"
          size="sm"
          slot="allLevels.reset"
          slot-scope="data"
          @click.stop="confirmReset(data.data.installationId)"
        >
          <span
            class="material-icons"
          >
            rotate_left
          </span>
        </b-button>
      </multi-level-table>
    </div>
    <grid-paginator
      v-model="currentPageProxy"
      :per-page="perPage"
      :total-rows="totalRows"
    />
  </div>
</template>

<script>
import networkStatusService from '@/domain/services/generalPanel/networkStatus';
import NetworkStatusBadge from '@/domain/components/generalPanel/networkStatus/NetworkStatusBadge';
import ModuleStatusBadge from '@/domain/components/generalPanel/networkStatus/ModuleStatusBadge';
import ModuleSelfDiagnosisStatusBadge from '@/domain/components/generalPanel/networkStatus/ModuleSelfDiagnosisStatusBadge';
import GridPaginator from '@/components/lists/Paginator';
import MultiLevelTable from '@/components/lists/MultiLevelTable';
import NetworkStatusTableFields
  from '@/domain/data/generalPanel/networkStatus/networkStatusTableFields';

export default {
  name: 'NetworkStatusTable',
  props: {
    items: Array,
    currentPage: Number,
    totalRows: Number,
    perPage: Number,
    sortBy: String,
    sortDirection: String,
    loading: Boolean,
  },
  components: {
    GridPaginator,
    MultiLevelTable,
    NetworkStatusBadge,
    ModuleStatusBadge,
    ModuleSelfDiagnosisStatusBadge,
  },
  computed: {
    levels() {
      return NetworkStatusTableFields.getLevels(this);
    },
    headers() {
      return NetworkStatusTableFields.getHeaders(this);
    },
    sortByProxy: {
      get() {
        return this.sortBy;
      },
      set(newValue) {
        this.$emit('update:sortBy', newValue);
      },
    },
    sortDirectionProxy: {
      get() {
        return this.sortDirection;
      },
      set(newValue) {
        this.$emit('update:sortDirection', newValue);
      },
    },
    currentPageProxy: {
      get() {
        return this.currentPage;
      },
      set(value) {
        this.$emit('update:currentPage', value);
      },
    },
  },
  methods: {
    confirmReset(installationId) {
      this.$confirmMessage({ code: 'MC058' }).accepted(() => {
        this.reset(installationId);
      });
    },
    async reset(installationId) {
      await networkStatusService.resetSensors(installationId);
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"
.network-status-table
  margin: 0

  &__row
    overflow: auto
    white-space: nowrap

  &__self-diagnosis-badge
    padding: 5px

  &__reset-button
    border-radius: 5px
    & span.material-icons
      vertical-align: bottom

  &__table
    ::v-deep
      & &th:nth-last-child(2)
        text-align: center !important

      & #head-selfDiagnosis
        white-space: normal
        position: relative
        max-width: 10rem

        &:after
          position: absolute
          top: calc(50% - 0.75rem)

    ::v-deep tr
      &.level-1 td:nth-child(2)
        text-align: left !important

  ::v-deep &__cell
    &-modules-level-bar
      padding-left: .5em
      padding-right: 0
      border-right: 5px solid $color-gray-medium-light

    &-modules-self-diagnosis
      display: flex
      justify-content: center
      text-align: center !important

      .input-copy-content
        &__copy-btn
          padding-left: 1em
</style>
